import React from "react";
import { motion } from "framer-motion";


/* VARIANTS */
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const cardVariant = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const IndustryChallenges = ({ title, description, cards }) => {
  return (
    <section className="industry-manage-section">
      <motion.div
        className="industry-manage-container"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        {/* HEADING */}
        <motion.h2
          className="section-title"
          variants={fadeUp}
        >
          {title}
        </motion.h2>

        {/* DESCRIPTION */}
        <motion.p
          className="industry-manage-desc"
          variants={fadeUp}
        >
          {description}
        </motion.p>

        {/* CARDS */}
        <motion.div
          className="industry-manage-cards"
          variants={containerVariants}
        >
          {cards.map((card, index) => (
            <motion.div
              className="industry-manage-card"
              key={index}
              variants={cardVariant}
              whileHover={{ y: -8 }}
              transition={{ type: "spring", stiffness: 200, damping: 15 }}
            >
              <div
                className="industry-manage-icon-box"
              >
             {card.icon}
              </div>

              <h3>{card.heading}</h3>
              <p>{card.text}</p>
            </motion.div>
          ))}
        </motion.div>
      </motion.div>
    </section>
  );
};

export default IndustryChallenges;
